module.exports = __webpack_public_path__ + "static/img/1021.ca90ead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme2/totalBattery/1021.png
// module id = aXKW
// module chunks = 68